const INITIAL_STATE = {
  error: false,
  loading: false,
  data: [],
};

const LoginOrder = (state = INITIAL_STATE, action) => {
  
  switch (action.type) {
    case "LOGIN_ORDER_REQUEST":
      return { loading: true, error: false, data: [] };
    case "LOGIN_ORDER_SUCCESS":
      return { loading: false, error: false, data: action.payload };
    case "LOGIN_ORDER_ERROR":
      return { loading: false, error: true, data: action.payload };
    default:
      return state;
  }

};

export default LoginOrder;
